import { render, staticRenderFns } from "./PacienteFicha.vue?vue&type=template&id=c729bc0e&scoped=true"
import script from "./PacienteFicha.vue?vue&type=script&lang=js"
export * from "./PacienteFicha.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c729bc0e",
  null
  
)

export default component.exports